export enum AmountType {
  FixedAmount = '1',
  AllBalance = '2',
  KeepFixedAmount = '3',
  RandomRange = '4',
  Custom = '5'
}

export enum TimeInterval {
  NoInterval = '1',
  FixedInterval = '2',
  RandomInterval = '3'
}